import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/esm/Modal";
import "../OtpValidationModal.css";
import "../SignupScreen.css";
import LoadingBox from "./LoadingBox";
import OtpInput from "./OtpInput";

export default function OtpValidationModal({
  showOtpValidation,
  setShowOtpValidation,
  handleValidateOtp,
  setOtpValidatingStatus,
  otpValidatingStatus,
  email,
}) {
  const onOtpComplete = (value) => {
    setOtpValidatingStatus(true);
    handleValidateOtp(value);
  };
  return (
    <Modal
      show={showOtpValidation}
      backdrop="static"
      onHide={() => {
        setShowOtpValidation(false);
      }}
      className="otp-modal"
    >
      <Modal.Header closeButton className="otp-modal-header">
        <Modal.Title className="otp-modal-title">
          Elektronik Doğrulama Kodu
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="otp-modal-body">
        {!otpValidatingStatus ? (
          <div className="otp-modal-body">
            <Form.Group className="mb-3 otp-form-group">
              <Form.Label className="text-danger text-muted otp-form-label">
                <div>
                  <span style={{ fontWeight: "bold" }}>{email}</span> adresine
                  gönderilen doğrulama kodunu giriniz!
                </div>

                <div style={{ fontSize: "14px" }}>
                  E-postanın size ulaşması, ağ hızına bağlı olarak bir veya iki
                  dakika sürebilir.
                </div>
              </Form.Label>
              <OtpInput onOtpComplete={onOtpComplete} />
            </Form.Group>
          </div>
        ) : (
          <LoadingBox>Doğrulama yapıliyor</LoadingBox>
        )}
      </Modal.Body>
    </Modal>
  );
}
